import SearchableFilter from './SearchableFilter.component';

export default SearchableFilter;
